<template>
  <div id="klimaDocuments" class="animated fadeIn">
    <!-- mobile view -->
    <div class="clearfix fullHeight">
      <div class="col-12 lg-col-4 md-col-9 py3 mx-auto mt3 shadow">
        <div @click="goToCheckList()" class="clearfix primarycolor flex justify-start items-center pointer">
        <span class="mr1"><i class="el-icon-back"></i></span>
        <span class="h5 gibson line-height-1 m0 p0">Tilbage</span>
      </div>
        <form-wizard ref="wizard" title="" subtitle="" shape="square" finishButtonText="Bekræft" color="" error-color="#ff4949" class="px1">
          <tab-content title="1 ud af 2" :before-change="validateFirstStep" class="klima-docs">
            <div class="mb3">
              <p class="h5 textgrey custom-letter-spacing gibson line-height-3">
                Dine klimaforbedringer skal dokumenteres i rapporten. Vedhæft billeder og/eller kvitteringer som bevis for at forbedringen er udført.
              </p>
            </div>
            <div class="highlights p3">
              <!-- header -->
              <p class="h5 gibson darkblue line-height-1 m0 p0">
                Dokumentation
              </p>
              <div class="py2"></div>
              <div class="clearfix" v-if="taskLoading">
                <div class="col-12">
                  <div class="loader"></div>
                </div>
              </div>
              <div v-else>
                <!-- single item for form with dropdown -->
                <div :id="'task-' + task.userplanId" v-for="(task, index) in taskData" :key="index" @mouseover="activePlanId(task.userplanId)">
                  <div class="col-12 mb2 px0 flex justify-between items-center">
                    <!-- toggle collapse -->
                    <button v-b-toggle="'documents-' + index" class="pl0 toggle-label-btn border-none white-background darkblue flex justify-start items-center" @click="validateAllAcceptButton()">
                      <span class="when-opened mr1">
                        <i class="el-icon-caret-bottom mediumgrey"></i>
                      </span>
                      <span class="when-closed mr1">
                        <i class="el-icon-caret-right darkblue"></i>
                      </span>
                      <p class="h5 m0 p0 caps semi-bold gibson darkblue line-height-1">
                        {{task.title}}
                      </p>
                    </button>
                    <!-- status icons for documents and images -->
                    <div class="flex justify-end items-end">
                      <span class="h4 mediumgrey mr2" v-if="task.fileList.length > 0">
                        <img src="/static/svg/icon_paperclip-green.svg">
                      </span>
                      <span class="h4 mediumgrey mr2" v-else>
                        <img src="/static/svg/icon_paperclip.svg">
                      </span>
                      <span class="h4 mediumgrey" v-if="task.imageList.length > 0">
                        <img src="/static/svg/camera-green.svg">
                      </span>
                      <span class="h4 mediumgrey" v-else>
                        <img src="/static/svg/camera.svg">
                      </span>
                    </div>
                  </div>
                  <b-collapse :id="'documents-' + index">
                    <div class="clearfix" v-if="uploadLoading">
                      <div class="col-12">
                        <div class="loader"></div>
                      </div>
                    </div>
                    <div v-else>
                      <div v-if="task.imageList.length > 0 || task.fileList.length > 0">
                        <div>
                          <div :class="'flex px3 mb3 docs-' + file.id" v-for="(file, index1) in task.fileList" :key="index1">
                            <div class="col-11 p0 mr2">
                              <div class="flex flex-wrap mb2">
                                <img src="/static/svg/icon_paperclip.svg" class="mr2">
                                <a target="_blank" :href="file.url" class="no-hover">{{file.id}}</a>
                              </div>
                              <div class="block">
                                <p class="m0">
                                  <span class="semi-bold block">Beskrivelse:</span>
                                  {{file.description}}
                                </p>
                              </div>
                            </div>
                            <div class="col-1 p0 flex flex-wrap items-center">
                              <a class="red bold pointer no-hover" v-confirm="{ok: confirmDelete(file.id, 'file', index), message: 'Vil du fjerne denne fil?', okText: 'Ja', cancelText: 'Nej'}"><i class="el-icon-delete"></i></a>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div :class="'flex px3 mb3 docs-' + img.id" v-for="(img, index2) in task.imageList" :key="index2">
                            <div class="col-11 p0 mr2">
                              <div class="flex flex-wrap mb2">
                                <img src="/static/svg/camera.svg" class="mr2">
                                <a target="_blank" :href="img.url" class="no-hover">{{img.id}}</a>
                              </div>
                              <div class="block">
                                <p class="m0">
                                  <span class="semi-bold block">Beskrivelse:</span>
                                  {{img.description}}
                                </p>
                              </div>
                            </div>
                            <div class="col-1 p0 flex flex-wrap items-center">
                              <a class="red bold pointer no-hover" v-confirm="{ok: confirmDelete(img.id, 'image', index), message: 'Vil du fjerne dette billede?', okText: 'Ja', cancelText: 'Nej'}"><i class="el-icon-delete"></i></a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <p class="mediumgrey px3 mb2" v-else>Ingen dokumenter eller fotos fundet</p>
                    <div v-if="!uploadLoading">
                      <b-form-input class="file-description col-12 mb2" placeholder="Beskrivelse"></b-form-input>
                      <div class="pt2 border-top transparent-border flex justify-center items-center mb3">
                        <div class="col-6 p0" @click="activeFileType('file')">
                          <file-upload-input token="" module="" @UpdateTilbud="handleFileUpload" class="klima-documentation btn-file"></file-upload-input>
                        </div>
                        <div class="col-6 p0" @click="activeFileType('camera')">
                          <file-upload-input token="" module="" @UpdateTilbud="handleFileUpload" class="klima-documentation btn-camera"></file-upload-input>
                        </div>
                      </div>
                    </div>
                    <button class="action-button p2 h4 gibson regular line-height-1 col-12 flex justify-center items-center mb3" v-b-toggle="'documents-' + index" v-if="!uploadLoading" @click="validateAllAcceptButton()">
                      <span>ACCEPTER</span>
                    </button>
                  </b-collapse>
                </div>
                <!-- <button class="action-button p2 h4 gibson regular line-height-1 col-12 flex justify-center items-center" v-b-toggle.values @click="updateDocument()">
                  <span>GEM</span>
                  <span class="pl1"><i class="el-icon-right"></i></span>
                </button> -->
                <!-- end single item -->
              </div>
            </div>
          </tab-content>
          <tab-content title="1 ud af 2" :before-change="validateSecondStep">
            <div class="mb3">
              <p class="h5 textgrey custom-letter-spacing gibson line-height-3">
                Se og afslut rapporten.
              </p>
            </div>
            <div class="highlights p3">
              <!-- header -->
              <p class="h5 gibson darkblue line-height-1 m0 p0">
                Godkendelse
              </p>
              <div class="clearfix" v-if="sendLoading">
                <div class="col-12">
                  <div class="loader"></div>
                </div>
              </div>
              <div class="py4" v-else>
                <div class="col-12 mb2 px0">
                  <button class="action-button preview-button p2 h5 gibson regular line-height-1 col-12 mb4" @click="previewDocuments()">
                    <span>PREVIEW</span>
                  </button>
                  <button class="action-button p2 h5 gibson regular line-height-1 col-12 flex justify-center items-center" :disabled="disableSend" @click="sendReport()">
                    <span>AFSLUT RAPPORT</span>
                  </button>
                </div>
              </div>
            </div>
          </tab-content>
          <div class="flex justify-start items-center col-12 px0 mt3 mb2">
            <div class="col-6 px1">
              <el-progress :percentage="progressbar[0].progress1" :show-text=false color="#4dcf55"></el-progress>
            </div>
            <div class="col-6 px1">
              <el-progress :percentage="progressbar[0].progress2" :show-text=false color="#4dcf55"></el-progress>
            </div>
            
          </div>
          <template slot="footer" slot-scope="props" v-if="!taskLoading && !uploadLoading && !sendLoading">
            <div class="wizard-footer-left flex-auto col-4">
              <wizard-button @click.native="props.prevTab()" class="flex items-start justify-start">
                <span class="block flex flex-column justify-start items-start">
                  <span class="block flex justify-start">
                    <i class="el-icon-back"></i>
                  </span>
                  <span class="h5 gibson line-height-1 mt2 regular darkblue mb0 block">Tilbage</span>
                </span>
              </wizard-button>
              <!-- <wizard-button  v-if="props.activeTabIndex > 0 && !props.isLastStep" :style="props.fillButtonStyle">Previous</wizard-button> -->
            </div>
            <div class="flex flex-column justify-center items-center gibson invisible">
              <template>
                <div @click="unitDialogVisible = true" class="mx-auto center border darkblue-border" style="height:48px;width:48px;border-radius:50%;line-height:48px;border:2px solid!important;">
                  <span class="green semi-bold" style="font-size:24px;"><i class="el-icon-plus"></i></span>
                </div>
              </template>
              <span class="center block h6 caps gibson darkblue line-height-1 mt2 mb0 p0">Tilføj enhed</span>
            </div>
            <div class="wizard-footer-right flex-auto">
              <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab()" class="flex flex-column items-end justify-end px0 col-12">
                <span class="block flex flex-column justify-end items-end">
                  <span class="block flex justify-end"><i class="el-icon-right"></i></span>
                  <span class="h5 gibson line-height-1 mt2 regular darkblue mb0 block">Næste</span>
                </span>
              </wizard-button>
              <wizard-button type="button" v-if="props.isLastStep" @click.native="props.nextTab()" class="flex flex-column items-end justify-end px0 col-12">
                <span class="block flex flex-column justify-start items-end">
                  <span class="block flex justify-end"><i class="el-icon-right"></i></span>
                  <span class="h5 gibson line-height-1 mt2 regular darkblue mb0 block">
                    {{props.isLastStep ? 'Færdig' : 'Næste'}}
                  </span>
                </span>
              </wizard-button>
            </div>
          </template>
        </form-wizard>
        <el-dialog
          class=""
          title="Preview"
          :visible.sync="previewDialog"
          width="70%"
          left>
          <div class="clearfix" v-if="previewLoading">
            <div class="col-12">
              <div class="loader"></div>
            </div>
          </div>
          <div v-else>
           <iframe :src="pdf" title="W3Schools Free Online Web Tutorials" class="col-12 iframe-height"></iframe>
          </div>
          <span slot="footer" class="dialog-footer flex justify-end">
            <div class="">
              <b-btn type="buttom" variant="secondary" size="lg" class="standard-button rounded" @click="previewDialog = false">
                Luk
              </b-btn>
            </div>
          </span>
        </el-dialog>
      </div>
    </div>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </div>
</template>
<script>
import Simplert from 'vue2-simplert'
import Dropzone from 'vue2-dropzone'
import fileUploadInput from '../../../components/file-upload-input'
export default {
  name: 'klimadokumentation',
  components: {
    Simplert,
    Dropzone,
    fileUploadInput
  },
  data () {
    return {
      taskLoading: true,
      uploadLoading: false,
      previewLoading: true,
      sendLoading: false,
      images: 0,
      documents: 0,
      contactId: '',
      klimaId: '',
      offer: '',
      taskData: [],
      progressbar: [
        {
          progress1: 100,
          progress2: 0
        }
      ],
      previewDialog: false,
      pdf: '',
      disableSend: true,
      allUserPlan: [],
      gatheredUserPlan: [],
      fileList: [],
      activePlan: '',
      activeFile: '',
      openCollapse: false
    }
  },
  created () {
    var pageName = this.$route.name
    if (pageName === 'klima') {
      console.log('this is Klima')
      // document.getElementById('appFooter').classList.add('hide')
    }
    this.salesPerson = localStorage.getItem('id_token_portal')
    this.haaId = localStorage.getItem('haaid')
    var urlStr = window.location.href
    var url = new URL(urlStr.replace('/#', ''))
    var searchParams = url.searchParams
    var klimaId = searchParams.get('klimaId')
    this.klimaId = klimaId
    var contactId = searchParams.get('contactId')
    this.contactId = contactId
    var appointmentId = searchParams.get('appointmentId')
    this.appointmentId = appointmentId
    this.displayTask()
  },
  dropzoneSettings () {
    let defaultValues = {
      thumbnailWidth: 200,
      thumbnailHeight: 200
    }
    Object.keys(this.options).forEach(function (key) {
      defaultValues[key] = this.options[key]
    }, this)
    if (this.awss3 !== null) {
      defaultValues['autoProcessQueue'] = false
      this.isS3 = true
      if (this.options.autoProcessQueue !== undefined) {
        this.wasQueueAutoProcess = this.options.autoProcessQueue
      }
    }
    return defaultValues
  },
  methods: {
    goToCheckList () {
      this.$router.push('/klima/checklist?appointmentId=' + this.appointmentId + '&contactId=' + this.contactId)
    },
    uploadDocument (doc) {
      var docs = doc.replace(' ', '%20')
      var description = document.querySelector('.wizard-tab-container #task-' + this.activePlan + ' input.file-description').value
      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        ContactId: this.contactId,
        CompanyId: this.haaId,
        parameters: JSON.stringify({
          levid: this.haaId,
          operation: 'uploadKlima',
          file: docs,
          description: description
        })
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.success) {
            this.addFile(res.data.fileId)
          } else {
            this.$toastr('error', 'Error in uploadDocument()')
          }
        },
        response => {
          this.$toastr('error', 'Error in uploadDocument()')
        }
      )
    },
    addFile (fileId) {
      for (var i = 0; i < this.allUserPlan.length; i++) {
        if (this.allUserPlan[i].userplanId === parseInt(this.activePlan)) {
          if (this.activeFile === 'file') {
            this.allUserPlan[i].files.push(fileId)
          } else if (this.activeFile === 'camera') {
            this.allUserPlan[i].images.push(fileId)
          }
          this.updateDocument()
        }
      }
    },
    updateDocument () {
      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        ContactId: this.contactId,
        CompanyId: this.haaId,
        parameters: JSON.stringify({
          draft: 0,
          klimaId: this.klimaId,
          operation: 'addKlima',
          ContactId: this.contactId,
          CompanyId: this.haaId,
          info: '',
          offerId: this.offer,
          userplan: this.allUserPlan,
          usersurvey: this.gatheredUserPlan
        })
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.success) {
            this.allUserPlan = []
            this.displayTask()
          } else {
            this.$toastr('error', 'Error in updateDocument()')
          }
        },
        response => {
          this.$toastr('error', 'Error in updateDocument()')
        }
      )
    },
    confirmDelete (id, type, index) {
      return dialog => this.deleteImage(id, type, index)
    },
    deleteImage (id, type, index) {
      document.querySelector('.docs-' + id).remove()
      if (type === 'file') {
        for (var i = 0; i < this.allUserPlan[index].files.length; i++) {
          if (this.allUserPlan[index].files[i] === parseInt(id)) {
            this.allUserPlan[index].files.splice(i, 1)
          }
        }
      } else {
        for (var j = 0; j < this.allUserPlan[index].images.length; j++) {
          if (this.allUserPlan[index].images[j] === parseInt(id)) {
            this.allUserPlan[index].images.splice(j, 1)
          }
        }
      }
      this.updateDocument()
      this.$toastr('success', 'Fjernet')
    },
    handleFileUpload (file) {
      var doc = 'https://www.kundematch.dk/HenttilbudImg.php?img=' + file[file.length - 1]
      this.uploadDocument(doc)
      this.uploadLoading = true
    },
    displayTask () {
      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        ContactId: this.contactId,
        CompanyId: this.haaId,
        parameters: JSON.stringify({
          operation: 'getKlima',
          ContactId: this.contactId,
          CompanyId: this.haaId
        })
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.success) {
            for (var i = 0; i < res.data.main.length; i++) {
              if (res.data.main[i].klimaId === this.klimaId) {
                this.taskData = res.data.main[i].user_group
                this.offer = res.data.main[i].offer
                for (var x = 0; x < res.data.main[i].user_group.length; x++) {
                  var planId = res.data.main[i].user_group[x].userplanId
                  var planTitle = res.data.main[i].user_group[x].title
                  var planFile = []
                  if (res.data.main[i].user_group[x].file !== false && res.data.main[i].user_group[x].file !== null) {
                    for (var j = 0; j < res.data.main[i].user_group[x].file.length; j++) {
                      var fileId = res.data.main[i].user_group[x].file[j]
                      planFile.push(parseInt(fileId))
                    }
                  }
                  var planImage = []
                  if (res.data.main[i].user_group[x].image !== false && res.data.main[i].user_group[x].image !== null) {
                    for (var k = 0; k < res.data.main[i].user_group[x].image.length; k++) {
                      var imageId = res.data.main[i].user_group[x].image[k]
                      planImage.push(parseInt(imageId))
                    }
                  }
                  var planInfo = res.data.main[i].user_group[x].info
                  var planUserType = res.data.main[i].user_group[x].user_type
                  if (planUserType.length === 0) {
                    planUserType = []
                  }
                  var planUserSurvey = []
                  if (res.data.main[i].user_group[x].user_survey.length > 0) {
                    for (var c = 0; c < res.data.main[i].user_group[x].user_survey.length; c++) {
                      var surveyId = res.data.main[i].user_group[x].user_survey[c]
                      planUserSurvey.push(parseInt(surveyId))
                    }
                  }
                  this.allUserPlan.push({
                    userplanId: parseInt(planId),
                    title: planTitle,
                    files: planFile,
                    images: planImage,
                    info: planInfo,
                    usertype: planUserType,
                    usersurvey: planUserSurvey
                  })
                  this.gatheredUserPlan = res.data.main[i].user_survey
                }
                setTimeout(() => {
                  var btnFile = document.querySelectorAll('.klima-documentation.btn-file > .input-group > button')
                  for (var i = 0; i < btnFile.length; i++) {
                    btnFile[i].innerHTML = '<button class="action-button upload-button p2 h4 col-12 gibson regular line-height-1 flex justify-center items-center border rounded m0"><span class="mr2"><i class="el-icon-paperclip"></i></span><span>VEDHÆFTET</span></button>'
                  }
                  var btnCamera = document.querySelectorAll('.klima-documentation.btn-camera > .input-group > button')
                  for (var j = 0; j < btnCamera.length; j++) {
                    btnCamera[j].innerHTML = '<button class="action-button upload-button p2 h4 col-12 gibson regular line-height-1 flex justify-center items-center border rounded m0"><span class="mr2"><i class="el-icon-camera"></i></span><span>KAMERA</span></button>'
                  }
                }, 500)
                this.taskLoading = false
                this.uploadLoading = false
              }
            }
          } else {
            this.$toastr('error', 'Error in displayTask()')
          }
        },
        response => {
          this.$toastr('error', 'Error in displayTask()')
        }
      )
    },
    activeFileType (type) {
      this.activeFile = type
      var acceptedFiles = ''
      if (type === 'file') {
        acceptedFiles = '.doc, .pdf'
      } else if (type === 'camera') {
        acceptedFiles = '.jpg, .png'
      }
      document.querySelector('.wizard-tab-container #task-' + this.activePlan + ' .btn-' + type + ' input').setAttribute('accept', acceptedFiles)
    },
    activePlanId (planId) {
      this.activePlan = planId
    },
    validateAllAcceptButton () {
      setTimeout(() => {
        var collapseBtn = document.querySelectorAll('.klima-docs .collapse')
        this.openCollapse = false
        for (var i = 0; i < collapseBtn.length; i++) {
          if (collapseBtn[i].classList.contains('show')) {
            this.openCollapse = true
          }
        }
      }, 500)
    },
    validateFirstStep () {
      var validation = ''
      if (!this.openCollapse) {
        validation = true
        this.progressbar[0].progress2 = 100
      } else {
        validation = false
        this.$toastr('error', 'Klik på knappen Accepter')
      }
      return validation
    },
    validateSecondStep () {
      var validation = ''
      if (this.disableSend) {
        validation = false
      } else {
        validation = true
      }
      if (validation) {
        this.onComplete()
      } else {
        this.$toastr('error', 'Se eksempler på dokumenterne')
      }
      return validation
    },
    onComplete () {
      this.sendReport()
    },
    previewDocuments () {
      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        ContactId: this.contactId,
        CompanyId: this.haaId,
        parameters: JSON.stringify({
          operation: 'previewKlimaReport',
          ContactId: this.contactId,
          CompanyId: this.haaId,
          klimaId: this.klimaId,
          to: 'partner'
        })
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.success) {
            this.pdf = res.data.pdf
            this.previewLoading = false
            this.disableSend = false
          } else {
            this.$toastr('error', 'Error in previewDocuments()')
          }
        },
        response => {
          this.$toastr('error', 'Error in previewDocuments()')
        }
      )
      this.previewDialog = true
      this.previewLoading = true
    },
    sendReport () {
      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        ContactId: this.contactId,
        CompanyId: this.haaId,
        parameters: JSON.stringify({
          operation: 'sendKlimaReport',
          ContactId: this.contactId,
          CompanyId: this.haaId,
          klimaId: this.klimaId,
          to: 'customer'
        })
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.success) {
            let obj = {
              title: 'Gennemført!',
              message: '',
              type: 'success',
              customCloseBtnText: 'Luk'
            }
            this.$refs.simplert.openSimplert(obj)
            // this.sendLoading = false
            setTimeout(() => {
              this.gotoChecklist()
            }, 3000)
          } else {
            this.$toastr('error', 'Error in sendReport()')
          }
        },
        response => {
          this.$toastr('error', 'Error in sendReport()')
        }
      )
      this.sendLoading = true
    },
    gotoChecklist () {
      this.$router.push('/klima/checklist?appointmentId=' + this.appointmentId + '&contactId=' + this.contactId)
    }
  },
  /*   computed: {
    currentRouteName () {
      let currentPage = this.$route.fullPath
      return currentPage
    }
  }, */
  /* watch: {
    '$route.fullPath' (to, from) {
      let currentPage = this.$route.fullPath
      if (currentPage === '/klima/klimadokumentation') {
        console.log('this is /klima/klimadokumentation')
      }
    }
  }, */
  mounted () {
    /* var currentPage = this.$route.fullPath
    if (currentPage === '/klima/klimadokumentation') {
      console.log('this is /klima/klimadokumentation')
      document.getElementById('appFooter').classList.add('hide')
    } */
    /* document.onreadystatechange = () => {
      if (document.readyState === 'complete') {
        console.log('Page completed with image and files!')
      }
    } */
  }
}
</script>
<style lang="less">
ul.upload-file > li > span {
    margin-bottom: 0;
}
.itemDot {
  display: inline-block;
  position: relative;
}
.itemDot:after {
  content: '';
  position: absolute;
  left:-4px;
  top:4px;
  height:8px;
  width:8px;
  border-radius: 50%;
  background-color: rgba(0, 54, 69, 1.0);
}
.vue-dropzone {
  width:100%;
  min-height:0;
  padding: 0;
  border: 0;
  background: transparent;
  color: white!important;
  &:hover {
    background: transparent;
  }
  i {
    color: white!important;
  }
}
#klimaDocuments button.toggle-label-btn.not-collapsed {
  pointer-events: none;
}
.dz-preview {
  display: none!important;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.vue-form-wizard .wizard-card-footer {
  display: flex;
  justify-content: between;
  justify-items: center;
  padding:0;
  margin-top:20px;
}
.vue-form-wizard .wizard-btn {
  padding: 0!important;
}
.wizard-tab-content {
  padding-top: 0!important;
  padding-right: 0!important;
  padding-left: 0!important;
}
.wizard-progress-with-circle,
.wizard-nav {
  display: none!important;
}
.modal-footer {
  padding: 0;
}
.modal-header > div:nth-child(1),
.modal-footer > div:nth-child(1) {
  width:100%;
}
.klima-documentation > .input-group > button {
  padding: 0;
  border: none !important;
}
#klimaDocuments .preview-button {
  background: #19a3c0;
  border: 1px solid #19a3c0;
}
#klimaDocuments .upload-button {
  background: #19a3c0;
  border: 1px solid #19a3c0;
}
#klimaDocuments .el-dialog {
  margin-top: 4rem !important;
}
#klimaDocuments .iframe-height {
  height: 70vh;
}
#klimaDocuments button.action-button:disabled {
  opacity: 0.5;
  background-color: grey;
}
#klimaDocuments ul.upload-file-list {
  display: none;
}
.loader,
  .loader:before,
  .loader:after {
    border-radius: 50%;
  }
  .loader {
    color: #143130;
    font-size: 11px;
    text-indent: -99999em;
    margin: 55px auto;
    position: relative;
    width: 10em;
    height: 10em;
    box-shadow: inset 0 0 0 1em;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
  }
  .loader:before,
  .loader:after {
    position: absolute;
    content: '';
  }
  .loader:before {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 10.2em 0 0 10.2em;
    top: -0.1em;
    left: -0.1em;
    -webkit-transform-origin: 5.2em 5.1em;
    transform-origin: 5.2em 5.1em;
    -webkit-animation: load2 2s infinite ease 1.5s;
    animation: load2 2s infinite ease 1.5s;
  }
  .loader:after {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 0 10.2em 10.2em 0;
    top: -0.1em;
    left: 5.1em;
    -webkit-transform-origin: 0px 5.1em;
    transform-origin: 0px 5.1em;
    -webkit-animation: load2 2s infinite ease;
    animation: load2 2s infinite ease;
  }
  @-webkit-keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// dokumentation.vue?2f0819d3